export const Logo = ({ light = false, className = "" }) => {
  const navy = light ? "#FFFFFF" : "#0A2342";
  const gold = "#C8A24A";
  const emblem = light ? "/brand/emblem-light.png" : "/brand/emblem-dark.png";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo">
      <img src={emblem} alt="CoreDock Logistics" className="h-11 w-auto object-contain" />
      <div className="leading-none">
        <span className="font-display font-extrabold text-[1.2rem] tracking-tight" style={{ color: navy }}>
          COREDOCK
        </span>
        <span className="block font-display uppercase tracking-[0.34em] text-[0.55rem] font-semibold mt-1"
              style={{ color: gold }}>
          Logistics
        </span>
      </div>
    </div>
  );
};
